var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 734,
    height: 773,
    viewBox: "0 0 734 773",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1186_113760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618 314.5C618 402.589 546.589 474 458.5 474C370.411 474 299 402.589 299 314.5C299 226.411 370.411 155 458.5 155C546.589 155 618 226.411 618 314.5Z",
    fill: "#BB1F46",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1186_113760",
    x: 0.869141,
    y: -143.131,
    width: 915.262,
    height: 915.262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 149.065,
    result: "effect1_foregroundBlur_1186_113760"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundBlur);
export default __webpack_public_path__ + "static/media/background-blur.c0d12d246c4aab0c79fe7c595841d0c6.svg";
export { ForwardRef as ReactComponent };